module.exports = __webpack_public_path__ + "assets/images/project/map-logos/2-aws.png?v=91e7e7c6";